<template lang="html">
  <div class="row download-container m-0 py-4">
    <div class="col-md-12">
      <h2 class="text-light text-center h1 text-uppercase">Download</h2>
    </div>
    <div class="col-md-12 d-flex align-items-center justify-content-center flex-column">
      <a class="btn py-2 my-2 download-btn" href="#" rel="noopener"><i class="fa fa-android"></i> Download </a>
      <a class="btn py-2 my-2 download-btn" href="#" rel="noopener"><i class="fa fa-apple"></i> Download </a>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
.download-container{
  background: #f65858
}
.download-btn{
  background: #FFFF;
  color: #f65858;
  border-radius: 18px;
  font-size: 1.6em
}
.download-btn:hover{
  background: #f65858;
  color: #FFF;
  border: 1px solid #FFF;
}
</style>
